<template>
    <div class="location">
        <div class="location__map">
            <div class="location__btns">
                <a v-if="model.AudioUrl != ''" class="location__button button"><img src="/public/img/volume.svg" alt="">Download Audio Guide</a>
                <a v-if="model.PDFUrl != ''" class="location__button button"><img src="/public/img/pdf.svg" />Download Route PDF</a>
                <a v-if="model.GPXUrl != ''" class="location__button button"><img src="/public/img/route.svg" />Download Route GPX</a>
            </div>
        </div>
        <div class="location__sidebar">
            <h2 class="location__title title">{{model.Name}}</h2>
            <ul class="location__options">
                <li>
                    <div class="location__icon"><img src="/public/img/route.svg" alt=""></div>
                    <div class="location__text">{{model.Difficulty}}</div>
                </li>
                <li>
                    <div class="location__icon"><img src="/public/img/clock.svg" alt=""></div>
                    <div class="location__text">{{model.Duration}}</div>
                </li>
                <li>
                    <div class="location__icon"><img src="/public/img/mountains.svg" alt=""></div>
                    <div class="location__text">{{Math.round(model.Elevation)}} M</div>
                </li>
                <li>
                    <div class="location__icon"><img src="/public/img/distance.svg" alt=""></div>
                    <div class="location__text">{{Math.round(model.Distance / 1000)}} KM</div>
                </li>
            </ul>
            <ol class="location__list">
                <li v-for="item in model.POIs" :class="{ 'active' : item.Selected }">
                    <div class="location__subtitle">{{item.Title}}</div>
                    <div class="location__content" v-html="item.Description"></div>
                </li>
            </ol>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            routeId: Number
        },
        data() {
            return {
                model: {
                    Name: '',
                    Duration: '',
                    Difficulty: '',
                    Elevation: 0,
                    Distance: 0,
                    GPXUrl: '',
                    AudioUrl: '',
                    PDFUrl: '',
                    Points: [],
                    POIs: []
                },
                map: null,
                path: null,
                infoWindow: null,
                infoOpen: false,
                bounds: null,
                gRoutePoints: []
            }
        },
        watch: {
        },
        methods: {
            createMap() {
                var vm = this
                var position = new google.maps.LatLng(49.5799965, -2.3327157)
                var el = vm.$el.querySelector('.location__map')
                vm.map = new google.maps.Map(el, {
                    zoom: 12,
                    maxZoom: 18,
                    minZoom: 5,
                    center: position,
                    panControl: false,
                    scrollwheel: true,
                    streetViewControl: false,
                    gestureHandling: 'greedy',
                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                    styles: [{
                        featureType: "poi",
                        elementType: "labels",
                        stylers: [{ visibility: "off" }]
                    },
                    {
                        featureType: "transit",
                        elementType: "labels",
                        stylers: [{ visibility: "off" }]
                    }]
                })
                vm.bounds = new google.maps.LatLngBounds()
                vm.infoWindow = new google.maps.InfoWindow({
                    content: '',
                    maxWidth: 320
                })
                google.maps.event.addListener(vm.infoWindow, 'closeclick', function () {
                    vm.infoWindowClose()
                })
            },
            createPath() {
                this.path = new google.maps.Polyline({
                    path: this.gRoutePoints,
                    strokeOpacity: 0,
                    icons: [{
                        icon: {
                            path: 'M 0,-1 0,1',
                            strokeColor: '#009DBB',
                            strokeOpacity: 1,
                            scale: 3
                        },
                        offset: 0,
                        repeat: '10px'
                    }]
                })
                this.path.setMap(this.map)
            },
            createStartEnd() {
                new google.maps.Marker({
                    position: this.gRoutePoints[0],
                    icon: {
                        path: google.maps.SymbolPath.CIRCLE,
                        scale: 8,
                        strokeColor: '#FFFFFF',
                        strokeWeight: 2,
                        fillColor: '#36AB45',
                        fillOpacity: 1
                    },
                    map: this.map
                })
                new google.maps.Marker({
                    position: this.gRoutePoints[this.gRoutePoints.length - 1],
                    icon: {
                        path: google.maps.SymbolPath.CIRCLE,
                        scale: 8,
                        strokeColor: '#FFFFFF',
                        strokeWeight: 2,
                        fillColor: '#e02121',
                        fillOpacity: 1
                    },
                    map: this.map
                })
            },
            createPOIs() {
                var vm = this
                var poiOverlay = new google.maps.OverlayView()
                poiOverlay.draw = function () {
                    this.getPanes().markerLayer.id = 'poilayer'
                }
                poiOverlay.setMap(vm.map)
                for (var i = 0; i < vm.model.POIs.length; i++) {
                    var poi = vm.model.POIs[i]
                    var content = `<h4>${poi.Title}</h4>`
                    if (poi.Description != null) {
                        content += `<p>${poi.Description}</p>`
                    }
                    var pos = new google.maps.LatLng(poi.Point.Lat, poi.Point.Lon)
                    vm.bounds.extend(pos)
                    var m = new google.maps.Marker({
                        position: pos,
                        icon: {
                            url: `/public/img/marker.png`,
                            size: new google.maps.Size(31, 31),
                            origin: new google.maps.Point(0, 0),
                            anchor: new google.maps.Point(15, 15),
                            scaledSize: new google.maps.Size(31, 31),
                            labelOrigin: new google.maps.Point(16, 16)
                        },
                        label: {
                            color: '#1898D9',
                            text: (i + 1).toString()
                        },
                        title: poi.Title,
                        content: content,
                        map: this.map,
                        optimized: false,
                        data_id: poi.Id
                    })
                    m.POI = poi
                    google.maps.event.addListener(m, 'click', function () {
                        vm.markerClick(this)
                    })
                }


            },
            markerClick(marker) {
                if (this.infoOpen) {
                    this.infoWindow.close()
                    this.infoWindowClose()
                    this.infoOpen = false
                } else {
                    this.infoWindow.setContent(marker.content)
                    this.infoWindow.open(this.map, marker)
                    marker.POI.Selected = true
                    this.infoOpen = true
                }
            },
            infoWindowClose() {
                this.model.POIs.map(p => p.Selected = false)
            },
        },
        mounted() {
            var vm = this
            vm.doPost('/umbraco/surface/route/getroutedata', { routeId: vm.routeId }, (data) => {
                vm.model = data

                //Convert gpx points into Google points
                this.gRoutePoints = this.model.Points.map(p => new google.maps.LatLng(p.lat, p.lon))

                this.createMap()
                this.createPath()
                this.createStartEnd()
                this.createPOIs()

                for (var n = 0; n < this.gRoutePoints.length; n++) {
                    this.bounds.extend(this.gRoutePoints[n])
                }

                this.map.fitBounds(this.bounds)
            })

        }
    }
</script>